import React, { Component, createRef, useContext, useEffect, useState } from 'react';
import {motion} from "framer-motion";
import axios from 'axios';
import {AppContext} from "../../context/app/appContext";
import {useHistory} from "react-router-dom";
import {Dimmer, Loader} from "semantic-ui-react";

const containerStyle = {
    position:"relative",
    width:"3em",
    height:"3em"
}
const circleStyle = {
    display:"block",
    width:"3em",
    height:"3em",
    border:"0.5rem solid #E9E9E9",
    borderRadius:"50%",
    borderTop: "0.5rem solid #3498DB",
    position:"absolute",
    boxSizing:"border-box",
    top:0,
    left:0
}
const spinTransition = {
    loop: 'Infinity',
    duration:1,
    ease: "linear"
}

const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

export const LoginGoogleRedirect1 = (props) => {
    const googleLoginBtn = createRef();
    const history = useHistory();
    const appContext = useContext(AppContext);

    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackMessageClass, setFeedbackMessageClass] = useState('error');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');

    useEffect(() => {
        googleSDK();
    }, []);

    const getLoginType = async (email, id) => {
        const response = await axios.post(baseURL + '/login-type', {email: email, integrationId: id});
        if(response.status === 200){
            if(response.data.data && response.data.data.loginType !== undefined){
                const loginType = response.data.data.loginType
                return loginType
            }
        }
        return null
    }

    const googleSDK = () => {
        window['googleSDKLoaded'] = () => {
          window['gapi'].load('auth2', () => {
            const auth2 = window['gapi'].auth2.init({
              client_id: '150906851550-83odcn88j08623a6nceq3bn64957q1d3.apps.googleusercontent.com',
              cookiepolicy: 'single_host_origin',
              scope: 'profile email'
            });
            prepareLoginButton(auth2);
          });
        }
     
        (function(d, s, id){
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {return;}
          js = d.createElement(s); js.id = id;
          js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'google-jssdk'));
    }

    const prepareLoginButton = (auth2) => {
        auth2.signIn().then(async googleUser => {
            let profile = googleUser.getBasicProfile();
            const googleToken = googleUser.getAuthResponse().id_token;
            const integrationIdGoogle = profile.getId();
            const nameGoogle = profile.getName();
            const firstNameGoogle = nameGoogle.split(" ")[0]
            const lastNameGoogle = nameGoogle.split(" ").length > 1 ? nameGoogle.split(" ")[nameGoogle.split(" ").length-1] : 'LNU'
            const emailGoogle = profile.getEmail();
            const integrationTypeGoogle = 'google'
            // console.log('Token || ' + googleUser.getAuthResponse().id_token);
            // console.log('ID: ' + profile.getId());
            // console.log('Name: ' + profile.getName());
            // console.log('Image URL: ' + profile.getImageUrl());
            // console.log('Email: ' + profile.getEmail());

            const loginType = await getLoginType(emailGoogle, integrationIdGoogle);
            console.info({loginType})
            if(loginType === 'verified'){
                try{
                    const dashboardLoginRequest = await axios.post(`${baseURL}/dashboard-integration-login`, {email: emailGoogle, integrationType: integrationTypeGoogle, integrationId: integrationIdGoogle}).catch(error => {
                        console.info({error});
                        setLoading(false);
                        if (error.isAxiosError && error.response.data && error.response.data.status) {
                            const {code, message} = error.response.data.status;
                            console.info({code, message});
                            return showFeedbackMessage(message);
                        }
                        return showFeedbackMessage(`Sorry, there was an error. Please try again later.`);
                    });
            
                    if (dashboardLoginRequest && dashboardLoginRequest.data && dashboardLoginRequest.data.data) {
                        const {code, message} = dashboardLoginRequest.data.status;
                        console.info({code, message});
            
                        const user = dashboardLoginRequest.data.data;
                        console.log('check user info here')
                        console.info({user});
                        if (user && user.accessToken) {
                            localStorage.setItem('accessToken', user.accessToken);
                            localStorage.setItem('email', user.accessToken);
                            await appContext.setAuthorizedUser(user);
                            await appContext.setOrganization(user.accessToken); // TODO: should be in Organization page load, so that each time it can be reloaded
                            setLoading(false);
                            // once logged-in fetch-organization API will pick organizationId from token
                        }
                        if(user.role === "SuperAdmin") {console.log("Super admin logged in"); setLoading(false); history.push('/super');} else await appContext.setOrganization(user.accessToken)
                    }
                } catch (error) {
                    setLoading(false);
                    console.info({error});
                    if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
                    history.goBack();
                }
            }else if(loginType === 'unverified'){
                try{
                    setLoading(true);
                    setErrors('');
                    const response = await axios.post(`${baseURL}/unverified-org/setup`, {email: emailGoogle, integrationId: integrationIdGoogle});
                    const unverifiedOrgData = response.data.data;
                    console.info(unverifiedOrgData);

                    const {
                        legalEntityName, mobile, email, firstName, lastName, _id,
                        website, entityType, merchantCategoryCode, primaryContactDOB, linkedInProfile, signatoryType,
                        street, city, state, country, zip, createdAt, updatedAt,
                    } = unverifiedOrgData;

                    localStorage.setItem('accessToken', _id);
                    localStorage.setItem('email', email);

                    const unverifiedUser = {accessToken: _id, email, firstName, lastName,};

                    const unverifiedOrg = {
                        verified: false,
                        EIN: '',
                        legalEntityName: legalEntityName || '',
                        entityType: entityType || 'company',
                        merchantCategoryCode: merchantCategoryCode || '',
                        website: website || '',
                        street: street || '',
                        city: city || '',
                        state: state || '',
                        zip: zip || '',
                        country: country || '',
                        createdAt: createdAt || '',
                        updatedAt: updatedAt || '',
                        primaryContact: {
                            firstName,
                            lastName,
                            email,
                            contactNumber: mobile,
                            signatoryType: signatoryType || '',
                            linkedInProfile: linkedInProfile || '',
                            dateOfBirth: primaryContactDOB || '',
                        },
                        secondaryContact: {
                            firstName: '',
                            lastName: '',
                            contactNumber: '',
                            email: '',
                            linkedInProfile: '',
                        },
                        peopleOpsContact: {
                            firstName: '',
                            lastName: '',
                            phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                            email: '',
                        },
                        perkBudgetApproverContact: {
                            firstName: '',
                            lastName: '',
                            phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                            email: '',
                        },
                    }
        
                    await appContext.setUnverifiedOrganization(unverifiedOrg); // TODO: should be in Organization page load, so that each time it can be reloaded
                    await appContext.setUnverifiedUser(unverifiedUser); // TODO: should be in Organization page load, so that each time it can be reloaded
        
                    setLoading(false);
        
                    console.info('redirecting to my-org');
                    history.replace(`/`);
                } catch (error) {
                    setLoading(false);
                    console.info({error});
                    if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
                    history.goBack();
                }
            }else{
                try{
                    setLoading(true);
                    setErrors('');
                    const response = await axios.post(`${baseURL}/start-trial/integration`, {email: emailGoogle, firstName: firstNameGoogle, lastName: lastNameGoogle, integrationType: integrationTypeGoogle, integrationId: integrationIdGoogle});
                    const unverifiedOrgData = response.data.data;
                    console.info(unverifiedOrgData);

                    const {
                        legalEntityName, mobile, email, firstName, lastName, _id,
                        website, entityType, merchantCategoryCode, primaryContactDOB, linkedInProfile, signatoryType,
                        street, city, state, country, zip, createdAt, updatedAt,
                    } = unverifiedOrgData;

                    const unverifiedUser = {accessToken: _id, email, firstName, lastName,};

                    localStorage.setItem('accessToken', _id);
                    localStorage.setItem('email', email);

                    const unverifiedOrg = {
                        verified: false,
                        EIN: '',
                        legalEntityName: legalEntityName || '',
                        entityType: entityType || 'company',
                        merchantCategoryCode: merchantCategoryCode || '',
                        website: website || '',
                        street: street || '',
                        city: city || '',
                        state: state || '',
                        zip: zip || '',
                        country: country || '',
                        createdAt: createdAt || '',
                        updatedAt: updatedAt || '',
                        primaryContact: {
                            firstName,
                            lastName,
                            email,
                            contactNumber: mobile,
                            signatoryType: signatoryType || '',
                            linkedInProfile: linkedInProfile || '',
                            dateOfBirth: primaryContactDOB || '',
                        },
                        secondaryContact: {
                            firstName: '',
                            lastName: '',
                            contactNumber: '',
                            email: '',
                            linkedInProfile: '',
                        },
                        peopleOpsContact: {
                            firstName: '',
                            lastName: '',
                            phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                            email: '',
                        },
                        perkBudgetApproverContact: {
                            firstName: '',
                            lastName: '',
                            phoneNumber: '', // TODO: change to contactNumber & map with real DB users
                            email: '',
                        },
                    }
        
                    await appContext.setUnverifiedOrganization(unverifiedOrg); // TODO: should be in Organization page load, so that each time it can be reloaded
                    await appContext.setUnverifiedUser(unverifiedUser); // TODO: should be in Organization page load, so that each time it can be reloaded
        
                    setLoading(false);
        
                    console.info('redirecting to my-org');
                    history.replace(`/`);
                } catch (error) {
                    setLoading(false);
                    console.info({error});
                    if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
                    history.goBack();
                }
            }
        }).catch(error => {
            console.log(error);
            history.goBack();
        })
    }

    useEffect(() => {
        if (appContext.user.accessToken && appContext.organization.legalEntityName) {
            history.replace(`/`);
        }
        // eslint-disable-next-line
    }, [appContext.organization, appContext.user])

    const showFeedbackMessage = (message, error = true) => {
        setFeedbackMessage(message);
        if (error) setFeedbackMessageClass('error');
        if (!error) setFeedbackMessageClass('success');
    }

    const loader = (
        <Dimmer active>
            <Loader size="large">loading...</Loader>
        </Dimmer>
    )

    const feedbackBlock = (
        <div className={`ui message ${feedbackMessageClass}`}>
            <div className="content">{feedbackMessage}</div>
        </div>
    );

    return (
        // <div style={containerStyle}>
        //         <motion.span 
        //         style={circleStyle}
        //         animate={{rotate:360}}
        //         transition={spinTransition}
        //         />
        //     </div> 
        <div style={{height: '100%', width: '100%'}}>
            {loading ? loader: null}
        </div>
    )
}